import { render, staticRenderFns } from "./PartidaModals.vue?vue&type=template&id=bd62ccec"
import script from "./PartidaModals.vue?vue&type=script&lang=js"
export * from "./PartidaModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports